export default {
  state: {
    steps: '',
    selectedStep: '',
  },
  getters: {
    selectedStep: (state) => state.selectedStep,
    steps: (state) => state.steps,
  },
  mutations: {
    increment(state, n) {
      state.selectedStep = n
    },
    ADD_STEPS(state, items) {
      state.steps = items
    },
  },
  actions: {},
}
